import React, { Component } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  height: 10vh;
  background: #fff;
  position: relative;
  box-shadow: 0px 2px 30px rgba(0, 0, 0, 0.1);
  width: 100vw;
  z-index: 999999;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  & > .button-menu {
    max-height: 70px;
  }
`

const Text = styled.div`
  font-size: 15px;
  color: rgb(204, 200, 200);
  font-weight: bold;
  text-align: center;
`

const User = styled.div`
  position: relative;
  left: 0;
  right: 0;
  margin-right: 10px;
  border-radius: 50px;
  background: ${({ collapse }) =>
    collapse ? "url('/assets/svg/close.svg')" : "url('/assets/svg/menu.svg')"};
  transform: ${({ collapse }) => (collapse ? 'rotate(90deg)' : '')};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 10vh;
  height: 10vh;
  transition: transform 0.5s ease;
`

const UserPannel = styled.div`
  width: auto;
  max-height: ${({ collapse }) => (collapse ? '250px' : 0)};
  opacity: ${({ collapse }) => (collapse ? 1 : 0)};
  position: absolute;
  right: 5px;
  top: 10vh;
  ${'' /* background: rgb(241, 240, 240) ; */} background: #fff;
  ${'' /* border: 2px solid rgb(241, 240, 240); */} ${'' /* border: 2px solid #fff; */}
  border-radius: 0px 0px 15px 15px;
  transition: max-height 1s ease, opacity 1s ease;
  ${'' /* box-shadow: ${({ collapse }) =>
    collapse ? '0px 5px 30px rgba(0, 0, 0, 0.1)' : 'none'}; */} box-shadow: 0px 2px 30px rgba(0, 0, 0, 0.1);
  overflow: ${({ collapse }) => (collapse ? 'visible' : 'hidden')};
  &::before {
    content: '';
    position: absolute;
    top: -10px;
    width: 100%;
    height: 10px;
    background: #fff;
  }
`

const MenuOption = styled.div`
  ${'' /* height: 20px; */} padding: 10px 10px;
  font-size: 15px;
  color: rgb(175, 174, 174);
  font-weight: bold;
  text-align: center;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
  &:hover {
    background-color: #8dbb54;
    color: #fff;
  }
  ${'' /* &:first-child {
    border-radius: 15px 15px 0px 0px;
  } */} &:last-child {
    border-radius: 0px 0px 15px 15px;
  }
`

const SearchIcon = styled.div`
  height: 10vh;
  width: 10vh;
  background: ${({ displaySearch }) =>
    displaySearch
      ? "url('/assets/svg/button-search-close.svg')"
      : "url('/assets/svg/button-search.svg')"};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border-radius: 100%;
  cursor: pointer;
  transform: ${({ displaySearch }) =>
    displaySearch ? 'rotate(-90deg)' : 'rotate(0deg)'};
  position: absolute;
  left: 25px;
  z-index: 9999;
  transition: transform 1s ease;
`

const Logo = styled.img`
  height: 10vh;
  cursor: pointer;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
`

class Pannel extends Component {
  constructor() {
    super()
    this.state = {
      collapse: false
    }
  }

  collapseMenu = () => {
    this.setState({
      collapse: !this.state.collapse
    })
  }

  render() {
    return (
      <Wrapper>
        <Logo
          src="/assets/logo/Logo-simple.png"
          onClick={() => window.open('http://www.afja-asso.fr/', '_blank')}
        />
        <User
          className="button-menu"
          collapse={this.state.collapse}
          onClick={this.collapseMenu}
        />
        {/* </div> */}
        {this.props.mediaQuery === 'smartphone' ? (
          <SearchIcon
            className="button-menu"
            onClick={this.props.searchClick}
            displaySearch={this.props.displaySearch}
          />
        ) : (
          ''
        )}

        <UserPannel collapse={this.state.collapse}>
          {this.props.admin ? (
            <MenuOption onClick={this.props.openAddMember}>
              Ajouter un membre
            </MenuOption>
          ) : (
            ''
          )}
          {this.props.admin ? (
            <MenuOption onClick={this.props.openAddUser}>
              Ajouter un client
            </MenuOption>
          ) : (
            ''
          )}
          {this.props.admin ? (
            <MenuOption onClick={this.props.displayUsers}>
              Gérer les clients
            </MenuOption>
          ) : (
            ''
          )}

          <MenuOption onClick={this.props.signOut}>Se déconnecter</MenuOption>
        </UserPannel>
      </Wrapper>
    )
  }
}

export default Pannel



// WEBPACK FOOTER //
// ./src/components/directory/pannel.js